/* eslint-disable sort-keys-fix/sort-keys-fix */
// NOTE: name should be lowercase as lowercase serializer is used.
export const IMPACT_PROGRAM_ROUTE = {
  name: 'impactprogram',
  route(): string[] {
    return ['/' + this.name];
  },
  DEFAULT: '',
  HOME: {
    name: 'home',
    route(): string[] {
      return [...IMPACT_PROGRAM_ROUTE.route(), this.name];
    }
  },
  ABOUT: {
    name: 'about',
    route(): string[] {
      return [...IMPACT_PROGRAM_ROUTE.route(), this.name];
    }
  },
  EXPERTS: {
    name: 'experts',
    route(): string[] {
      return [...IMPACT_PROGRAM_ROUTE.route(), this.name];
    }
  },
  IMPACT_AWARD: {
    name: 'impactaward',
    route(): string[] {
      return [...IMPACT_PROGRAM_ROUTE.route(), this.name];
    }
  },
  STORY: {
    name: 'story/:storyId',
    route(storyId: string): string[] {
      return [...IMPACT_PROGRAM_ROUTE.route(), 'story', storyId];
    }
  },
  DISTRICT: {
    name: 'district/:boardId',
    route(boardId: string): string[] {
      return [...IMPACT_PROGRAM_ROUTE.route(), 'district', boardId];
    }
  }
};
